export default __webpack_public_path__ + "static/rsvp-dc1d9e43dd87068f7092f216ef3cc59b.png";